<template>
  <Row ref="rowRef" class="grid-row-box">
    <Col class="grid-col-box"
      v-for="(item, ix) in dataList" :key="ix"
      :style="{height: dataList.length>=3?colHeight:''}"
      :class="{'big-size': dataList.length<3 }"
      :span="colSpan">
      <slot :data="item"></slot>
      <p class="float-screen" :style="btnStyle" v-if="showScreenBtn" @click="switchRobot(item)">
        <Icon :type="isFill ? 'md-contract' : 'md-expand'" :size="23"></Icon>
      </p>
      <!--v-show="item.isOffline"-->
      <div v-if="tipShow" class="center-tip tip--mark" >{{ item.tipContent || langMap.robotOffline[lang] }}</div>
    </Col>
  </Row>
</template>
<script>
import api from "@/api";
import { mapState } from 'vuex'
import langMap from '@/utils/language'

export default {
  props: {
    // 设置为2时每行可只显示两个
    maxColumns: {
      type: Number,
      default: 3
    },
    // >=3个元素时各元素高度
    colHeight: {
      type: String,
      default: ''
    },
    // 全屏按钮位置
    btnStyle: {
      type: Object,
      default: () => {
        return {top: '18px',right:'18px'}
      }
    },
    tipShow:{
      type:Boolean,
      default:true
    }
    // 是否显示全屏按钮
    // showScreenBtn: {
    //   type: Boolean,
    //   default: true
    // }
  },
  data() {
    return {
      langMap:langMap,
      dataList: [],
      lastIds: null,
      showScreenBtn: false,
      isFill: false, // 是否只打开1个情况
      tip: {
        showIx: -1,
        content:''
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language
    }),
    colSpan() {
      const W = 24;
      const len = this.dataList.length;
      if (len <= 1) return W;
      else if (this.maxColumns===2 || len===2) {
        return 12;
      } else {
        // >=3的情况
        return 8;
      }
    }
  },
  methods: {
    refreshList(array,showScreenBtnStatus) {
      this.dataList = array || [];
      const _idarr = array.map(v => v.id);

      if (_idarr.length > 1 && this.lastIds) this.lastIds = _idarr;
      else if (!this.lastIds && !showScreenBtnStatus) {
        this.showScreenBtn = _idarr.length > 1 ? true : false;
      }
    },
    switchRobot(robot, fill) {
      let _ids = [];

      if (!this.isFill) {
        // 进行展开
        this.lastIds = this.dataList.map(v => v.id);
        _ids = [robot.id];
      } else {
        // 关闭操作
        _ids = [...this.lastIds];
        this.lastIds = null;
      }

      api.postData('notice-server/usr/robot/save', { robotIds: _ids }, this).then(res => {
        this.isFill = !this.isFill;
      });
    },

    showTip(ix,state) {
      const el = this.$refs.rowRef.$el;
      let tipEl = el.getElementsByClassName('tip--mark')[ix];

      tipEl.style.display = 'block';
      tipEl.setAttribute('data-state', state);
      if (close) {
        setTimeout(() => {
          // 对全部提示进行状态检查
          let els = el.getElementsByClassName('tip--mark');
          for (let i = 0; i < els.length; i++){
            if(els[i].getAttribute('data-state') === 'online'){
              els[i].style.display = 'none';
            } else {
              els[i].style.display = 'block';
            }
          }
        }, 1600);
      }
    },
    // 指定元素进入全屏
    fullScreenByIndex(i) {
      const el = this.$refs.rowRef.$el;

      const dom = el.getElementsByClassName('grid-col-box')[i];

      this.isFill = false;
      this.switchScreen(dom);
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    switchScreen(dom) {
      if (this.isFill) {
        this.exitFullscreen();
      } else {
        if (dom.requestFullscreen) {
          dom.requestFullscreen()
        } else if (dom.mozRequestFullScreen) {
          dom.mozRequestFullScreen()
        } else if (dom.webkitRequestFullScreen) {
          dom.webkitRequestFullScreen()
        } else if (dom.msRequestFullscreen) {
          dom.msRequestFullscreen()
        }

      }

      this.isFill = !this.isFill;
    },
    handleFullscreen(item) {
      // const p = env.target.parentNode;
      // const el = p.parentNode;
      // this.switchScreen(el);

      this.$emit('handleScreen', item, this.isFill);
    }
  }
}
</script>
<style scoped lang="less">
.grid-row-box{
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #36373a;
}
.grid-col-box{
  position:relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  //align-items: center;
  &:hover{
    .float-screen{
      display: block;
    }
  }
  .float-screen{
    position: absolute;
    top: 18px;
    right: 18px;
    z-index: 10px;
    cursor: pointer;
    background-color: white;
    padding: 6px;
    margin: 0;
    //display: none;
  }
}
.big-size{
  height: 100%;
}
.center-tip{
  position: absolute;
  top: 48%;
  width: 90%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
  font-size: 20px;
  text-align: center;
  padding: 20px 0;
  color: white;
  left: 5%;
}
</style>
